import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { RemindersAnalyticsActions } from './reminders-analytics.actions';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';
import { TrackerQueryParams } from '@app/core/api/reminders-analytics';
import {
  selectRemindersOverview,
  selectRemindersTrend,
  selectRemindersTracker,
  selectRemindersLoading,
  selectRemindersError
} from './reminders-analytics.selectors';

@Injectable({
  providedIn: 'root'
})
export class RemindersAnalyticsFacade {
  private readonly store = inject(Store);

  readonly overview$ = this.store.select(selectRemindersOverview);
  readonly trend$ = this.store.select(selectRemindersTrend);
  readonly tracker$ = this.store.select(selectRemindersTracker);
  readonly loading$ = this.store.select(selectRemindersLoading);
  readonly error$ = this.store.select(selectRemindersError);

  loadOverview(params: AnalyticsQueryParams): void {
    this.store.dispatch(RemindersAnalyticsActions.loadOverview({ params }));
  }

  loadTrend(params: AnalyticsTrendQueryParams): void {
    this.store.dispatch(RemindersAnalyticsActions.loadTrend({ params }));
  }

  loadTracker(params: TrackerQueryParams): void {
    this.store.dispatch(RemindersAnalyticsActions.loadTracker({ params }));
  }

  clearState(): void {
    this.store.dispatch(RemindersAnalyticsActions.clearRemindersAnalyticsState());
  }
}
